<template>
  <div class="sdg sdgg stddss" style="width: 100%; background-color: #f1f1f1;">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7; z-index: 222" title="场馆转账" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>
    
    

<div class="venuesTansfer">

    <div class="accounts-scroll">
      <div class="automatic">
          <div class="text">
              <div class="tit">余额自动转入</div><span>启用后余额自动转入转出游戏场馆</span>
          </div>
          
          <van-switch @change="changeTasfer()" :active-value="1" :inactive-value="0" v-model="$store.state.userInfo.transferstatus" size="18px" active-color="#ff8439" inactive-color="#9ca3bf"/>
      </div>
      <div class="user-handle">
          <div class="first-handle">
              <div class="item from" @click="changShow('sourcetype')"><span>{{ sourcetype.name }}</span><img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAIAAADt1dgcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUMyOTFGNTkzNkUxMTFFQkFEODBCMUU1N0Y1MURGRUYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUMyOTFGNUEzNkUxMTFFQkFEODBCMUU1N0Y1MURGRUYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBQzI5MUY1NzM2RTExMUVCQUQ4MEIxRTU3RjUxREZFRiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBQzI5MUY1ODM2RTExMUVCQUQ4MEIxRTU3RjUxREZFRiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgGTNCEAAAErSURBVHjafJLvS8JAGMe92xjGYC9GIcMgoRFGTPOFIDL828WJoGg4s9EwG6kZZZBSup936zGjtRl9YbsPfJ7n7p6x1Gbj1OtX8A7/Cu50DNt2NU13XT+1F6wop7BQShuNvu8HSS2KQql0BkQI0bR+EJCYhieTEXd7eF7QbOqE0JiGZLNH+fwJgON4rdY1pWFMQ3I5SZaPAdZru92+gWvHNAQ0FAGsVh/d7i1UoF3V7wyH97PZC4AkHeL9WRH6wTCpTfNhOt22wsCFghzT4/GjZT0BCAJfLp8jhCI9mTyPRlMAnj+oVC7Q1xnfej5/NQwLIJ3mqlUFYxzNvVi8DQZ3ABzHqmqRYaIt8XL53uuZQAzDqOolyzKxb67r2z6MUa1WhO7klP//Dp8CDACTUKsnF2eCPgAAAABJRU5ErkJggg=="
                      class="arrowicon"></div><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAXCAIAAAD7ruoFAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTUyOTgwMDgzNkUxMTFFQkEyNkJCQTdFNUZDQUZGMEUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTUyOTgwMDkzNkUxMTFFQkEyNkJCQTdFNUZDQUZGMEUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5NTI5ODAwNjM2RTExMUVCQTI2QkJBN0U1RkNBRkYwRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5NTI5ODAwNzM2RTExMUVCQTI2QkJBN0U1RkNBRkYwRSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PojQjVYAAAGHSURBVHjazJaxa8JAFMZj1CTWWiQdDFIVRRcHk8lB0b/bUQJC1UEpNBkqtkop6WARgjWJNekrJ9drMHVKLh8ZvpAbfnnv8e5LeJ7HhCnLcsbjx1zuSpYbyST7z8lE2Cij0YNpfoIRBK7bbaXTqaCTLBOyEAcqj6rOHedADYXU4fA1HM72e5s+Csh1XVWd4VKRSh2P8NU9cbEsnqzdzrJtB3me57JZAXnD+NhuTeTz+Zwkichr2vN6/Y58uVxoNqtBNDCcMEDtdlMUb/5UBXMgZOwxh89jDp/HHD4fpMlEM4wNzQaRms+fSGiaKKiti8VrLFBAgKLrLz9jy8RAq5UBC5Bl4qHl8i0uKNVqMRYolYpUqxXpz0q9fgcP/bGFpQyr+bT4KXIoSkOSbn9XHIh8wR7unbMe7h3CX2OPfw5UKhUucsAdRHJEEZ0Gg3t/WkswnU4Lcp3/Zo64KVD4Xk/OZPgzISFKDkiTwMFxaTrRCTcCVnu/rwRxRDErEGmnUx2S18XE/y3AAB5zknDZwXKJAAAAAElFTkSuQmCC"
                  class="item icon">
              <div class="item to" @click="changShow('targettype')"><span>{{ targettype.name }}</span><img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAIAAADt1dgcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUMyOTFGNTkzNkUxMTFFQkFEODBCMUU1N0Y1MURGRUYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUMyOTFGNUEzNkUxMTFFQkFEODBCMUU1N0Y1MURGRUYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBQzI5MUY1NzM2RTExMUVCQUQ4MEIxRTU3RjUxREZFRiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBQzI5MUY1ODM2RTExMUVCQUQ4MEIxRTU3RjUxREZFRiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgGTNCEAAAErSURBVHjafJLvS8JAGMe92xjGYC9GIcMgoRFGTPOFIDL828WJoGg4s9EwG6kZZZBSup936zGjtRl9YbsPfJ7n7p6x1Gbj1OtX8A7/Cu50DNt2NU13XT+1F6wop7BQShuNvu8HSS2KQql0BkQI0bR+EJCYhieTEXd7eF7QbOqE0JiGZLNH+fwJgON4rdY1pWFMQ3I5SZaPAdZru92+gWvHNAQ0FAGsVh/d7i1UoF3V7wyH97PZC4AkHeL9WRH6wTCpTfNhOt22wsCFghzT4/GjZT0BCAJfLp8jhCI9mTyPRlMAnj+oVC7Q1xnfej5/NQwLIJ3mqlUFYxzNvVi8DQZ3ABzHqmqRYaIt8XL53uuZQAzDqOolyzKxb67r2z6MUa1WhO7klP//Dp8CDACTUKsnF2eCPgAAAABJRU5ErkJggg=="
                      class="arrowicon"></div>
          </div>
          <div class="second-handle">
              <div class="inputArea">
                  <div class="betInput van-cell van-field">
                      <div class="van-cell__title van-field__label"><span>￥</span></div>
                      <div class="van-cell__value van-field__value">
                          <div class="van-field__body"><input type="number" inputmode="decimal" v-model="amount" placeholder="请输入转账金额"
                                  class="van-field__control"></div>
                      </div>
                  </div><span class="all-into" @click="bigMey">全部转入</span>
              </div>
              <div class="bankbalance"><span class="text"></span>可转账金额<span class="number">0.00</span></div>
          </div><button @click="btnOk" class="lastbutton van-button van-button--default van-button--normal" :class="{hasInput:amount}">
              <div class="van-button__content"><span class="van-button__text">确认转账</span></div>
          </button>
      </div>
      <div class="topArea">
          <div class="venuesDetail">
              <div class="venues">
                  <div class="left-nums">场馆余额明细</div><span>点击查看全部场馆余额</span><!---->
                  
                  <img v-show="show1" @click="show1=!show1"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAADm0lEQVRYR82Y209TWRSHf+sU09YEY8R/w0jivDCJMTwjXkZlGJ0LIOp4gdBCsVCKx0JpS6eFyNwQVHQ0IjoDsfhMMg+SSeYBM/+GMxkvsaD2LHNau+TINtbiTjxPPTl7r+/r7tk7v1XCJ3TRJ+SCd8o0nRnfhgocIqCWiXcA8JYvTk+I8YCBBbzE7akfT/yjqrVGpqnpiseoeh4GI8iAUb6AeiYBFoMT/J87MjXVvLx6lEPGFnFVvVhkoPpjS7xdj4Cl3L8balYLOWRaOydiTBx8M5EyBKQf5Z78dXvEny1XsKUlUWls2bKDYfkBqi/WIab4ZOpYj9wXP7T4f91uuFxLq4ChyeSxoXIF3jWvNTDRCyBafG7lctWX098/sO9lZY4HJqIgsgfa19zF4db9H1ukWO949+QsgH35e6ahi8mjIYfMie5L90GoKUzgXeOJ1j91yZwMTOy0DKNQn7E4Pnz0c4fMyeDlZ/x6+3pX/t84so535H1f4pAv7a1yb35WEKDsL/HmjQ6ZUz1XuFjk51iz9sNQxRPo6dBVkfkp+p12GRVPoG1910RmbPBb7TIqnkDbw7+JzIWBb7TLqHgC7Th3XWRGz3+tXUbFE6jPvCEyI+YR7TIqnkA7z98UmdS5rxwyneZ0Agb7wNjwvm275jnhBSxOpczDcuzbY1Q8gQYGpkUmGW50yAQGpu0zYR0RAtlkuDF/lhQvFU+g3YO3RGa470uHzNnBWwkmlL0yxJRK9DU4VkbFE2hwaEZk4r0N2t8ZFU+gPbE7IhPrOahdRsUTaCj+u8hEgwe0y6h4Ag0P/yEyA91faJdR8QTan5wVmUhgv3YZFU+g5g9zImN27dMuo+IJNJK++5iBynzecVdWmqdrn37wAVfiBF96xrsZntd5Btl+/x5nnomMZO4DhaRn5axdZtdebUkvkp7fCeJi/cV+X70z6Q2OztshOZ+BCTQX6qjTloGjo5lZBhUyMDDU17HbmYEjqcx2V4XxpjsgDobadydKXPmSh0UvzJ8FU7w4IUdWdX97vbM7yCuO3YuBSfomAjIMI+l5+fhvv7+h7L4pnZ7xLlds+oyIu5h5j5gTx3vb6tb2TfYA01zweLauLIJZe0cJoqXlh+4a06yVFnfNFraFvFtXTIAD0NBr2/sDoGT2odtcLeLoDt7+0eNj97YZ5GoEoRawV4rWESE4C9ASGAsW56aDbXWl/QtR8puoYaD2k/ZDnF8BLKVoM2MipTIAAAAASUVORK5CYII=">

                  <img v-show="!show1" @click="show1=!show1" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAD1ElEQVRYR82Y709TVxjHv88trq0JixH/DSOJe8MSY3iNMNwUcT8p4u+V0EKxpRSPhdJeuhaUzYkwYL8yxG0Qi69J9kKyZC8w/hu6bLpYftj7mNvaI1fqcqi3iedVb3q+z/fTc+859/uU8BYNeotY8FqYti8n9qMKxwmoZ+KDANzlg9MTYtxnYBnPcHv267MPStXaBtPWNuPSajYiYAQZ0MoHKK0kwGCwzn87o7OznrWtsywwJoijZnOFgVq7IV6tR8Bq7tGuuq1AFpiO7sk4EwdfCilDQPrf3JM/b4/6s+UCtrfr1drevQcZhh+gxmIdYkpMpU6H5HXxQ7v/xgHN4VjdYhieSp4eLhfgdbqOwGQfgFjxeyOXq51On7tvXsuVOROYjIHInGiOxZsjHUftBinWO9M7tQCgOX/NNHwzeSpsgTnb+909EOoKAj48oXf8USmY84HJQ4amFeozViZGTr1vgTkfnH7KL7ave/2f3aOKz8i50LROTF4mXL0R98j7/38/5Lgv7a5x7nlaAKDstwnPbgvMhdAMFwtcj3uUD8MLoZkNALsAbF6Pe95RXc1SftL0Yvh7CfNN7AtlGDt10tTb/4OEGR/6XBnGTp007Yz8KGGuDX6mDGOnTpp2Xf5Jwoxd+VQZxk6dNPWJnyXMqPhEGcZOnTTtvvKLhEldPmmB6RZzOjT2gfO7ZmeDsAmDUynxsWXbl/KTpoHBOQmTjLRaYAKDc+aZ8AYRAtlkpDV/lhRHKT9p2jt0S8KM9J+wwFwauqUzoeyVIaaU3t9iWZlSftI0ODwvYRJ9LcrPjJ06aRqK/yph4qFjyjB26qRpOPGbhIkFP1KGsVMnTSMjv0uYwd4PlWHs1EnTgeSChIkGjirD2KmTpuKrRQkjepqVYURqcSN//hA2RXez8lu7lJ80jabvPGagOp93nNXV4mL9fyqnm0hldI3YawBXhb9JKc/40vPuPXC9yDPIDvibrHkmOpq5BxSSnpEzDoueDyqW9KLppUMgLtZfGfA1WpPe0NiSGZLzGZhAi+Guhopl4NhYZoFBhQwMDPd3HbFm4Ggqc8BRpb3sDoiD4c4jusqt2smc2LWlS2BKFDU5MmoHOhut3UEecfxuHEyybyIgw9CSrmeP//L7W8rum9Lpefda1bvvEXEPMzdJeOJEn7dhe99kThBi2eXat74C5op3lCBaXXvorBOiXra427awCeTety4ADqACvba5PwBKZh86xVYQS3fw6n1PjN/dr5GjFYR6wFwpeoMIwVmAVsFYNjg3F/Q2qP0LsZOH0e65yiet3cal6j0HzxOpM/w36wsAAAAASUVORK5CYII=">
              </div>
              <div class="venuesList" style="" v-show="show1">
                  <div class="top">
                      <div class="left">
                          <div class="left-top"><img
                                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDY1MkYwMTE1RkM3MTFFQjhCMzVFOTc4QzhDMzM5QkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDY1MkYwMTI1RkM3MTFFQjhCMzVFOTc4QzhDMzM5QkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowNjUyRjAwRjVGQzcxMUVCOEIzNUU5NzhDOEMzMzlCQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowNjUyRjAxMDVGQzcxMUVCOEIzNUU5NzhDOEMzMzlCQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvYajyUAAADpSURBVHjaYqzuWMbDwMCwFojdGKgLdgBxKAsjI+MyGhgOAh4gh7MwMTJ6M9AOuLEwMjEy0dACBpAPGGhrARMTrS2gsQ+YSffBPyBOBeL1QPyFFkGkB8Q3gDgGiLWI8AFJQTQbiK8B8UkgNgbid0Asgt8HzCT5YDkQqwKxKZS+A8RLgTiKmnHwC0r/p0UkRwJxOhCfBuJbQPwGiMWoGUSg1DMRiC2BOBgaD1SNZBC4hJRM19MimYI0zIVimmS0QVZU0L6wY2T8Bw1XWoB/oApnK5DhSyMLtoJ8AMrm64DYlcqG7wYVIQABBgABvyLx/uNgawAAAABJRU5ErkJggg=="><span
                                  class="main-number">主钱包</span></div><span class="money">¥ {{ amount1 }}</span>
                      </div><button @click="transall()" class="button onClickBack van-button van-button--default van-button--normal">
                          <div class="van-button__content"><span class="van-button__text">一键取回</span></div>
                      </button>
                  </div>

                  <div class="gameBox" v-if="balancelist.length">
                    <div class="lis" v-for="(item, index) in balancelist" v-if="index < showLis && index != 0" :key="index">
                      <div class="name">{{ item.name }}</div>
                      <div class="num">{{ item.balance }}</div>
                    </div>
                    <div class="lis" v-if="showLis != 4" @click="changShowLis(4)">
                      <div class="name">收起</div>
                      <div class="num"><img src="/static/image/xiangshang.png" alt="" /></div>
                    </div>
                    <div class="lis" v-if="showLis == 4" @click="changShowLis(balancelist.length )">
                      <div class="name">展开</div>
                      <div class="num"><img src="/static/image/xiangxia.png" alt="" /></div>
                    </div>
                  </div>

              </div>
          </div>
      </div>
  </div>
    
</div>
    
    
    
    
    
    
    
    
    
    
  </div>
</template>
<script>
export default {
  name: 'transfer',
  data() {
    return { show1:false, nshow: true, balancelist: [], openInfo: {}, amount: null, amount1: 0, payType: 0, openShow: false, daoTime: null, showLis: 4, show: false, type: 'sourcetype', sourcetype: { platname: 'userbalance', name: '平台钱包' }, targettype: {} };
  },
  created() {
    let that = this;
    that.getbalancelist();
    that.daoTime = setInterval(() => {
      that.getbalancelistNoLoding();
    }, 1500);
    this.amount1=this.$store.state.userInfo.balance + this.$store.state.userInfo.gameblance
    // console.log(this.amount1,' 看看我')
  },
  methods: {
    bigMey(){
      let that = this;
      // if(that.sourcetype.platname == 'userbalance'){
      //   that.amount = that.$store.state.userInfo.balance
      // }else{
      //   that.amount = that.sourcetype.balance*1

      // }
      that.amount = this.amount1
    },
    changShow(name) {
      this.type = name;
      this.show = true;
   
    },
    changApiType(name, val) {
      let that = this;
      that[name] = val;
      that.show = false;
      if(name == 'sourcetype'){
        that.amount = null;

      }
    },
    changShowLis(val) {
      this.showLis = val;
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.getbalancelist();
          that.refreshusermoney();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    btnOk() {
      let that = this;
      if(!this.amount) return
      if (that.amount == null || that.amount == '') {
        that.showTost(0, '请输入操作金额！');
        return;
      }
      if(that.sourcetype.platname != 'userbalance' && that.targettype.platname !='userbalance'){
        that.showTost(0, '场馆内钱包不支持互转');

        return
      }
      let info = { amount: that.amount, sourcetype: that.sourcetype.platname, targettype: that.targettype.platname };

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
        } else {
          that.hideLoading();
        }
      }) .catch(res => {
          that.$parent.hideLoading();
        });
    },
    isOk() {
      let that = this;

      let sourcetype = '';
      let targettype = '';

      if (that.payType == 0) {
        //转入游戏
        sourcetype = 'userbalance';
        targettype = that.openInfo.platname;
      } else {
        //转入平台
        sourcetype = that.openInfo.platname;
        targettype = 'userbalance';
      }
      let info = { amount: that.amount, sourcetype: sourcetype, targettype: targettype };
      if (that.amount == null) {
        that.showTost(0, '请输入操作金额！');
        return;
      }
      that.closeCv();

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
        } else {
          that.hideLoading();
        }
      });
    },
    closeCv() {
      let that = this;
      that.openInfo = {};
      that.amount = null;
      that.openShow = false;
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    getBalances() {
      let that = this;
      that.showLoading();
      that.getbalancelist();

      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          that.hideLoading();
        })
        .catch(res => {
          // console.log(res)
          that.hideLoading();
        });
    },
    changeTasfer() {
      let that = this;
      that.$parent.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = userInfo.transferstatus ? 0 : 1;

      that.$apiFun
        .post('/api/uptransferstatus', { transferstatus: mianzhuan })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
            that.$parent.showTost(1, '操作成功！');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changVal(item) {
      let that = this;
      // $store.state.userInfo.transferstatus == 0  0  转账模式  1免转模式
      if (that.$store.state.userInfo.transferstatus == 1) {
        return;
      }
      that.openInfo = item;
      that.openShow = true;
      that.amount = null;
    },
    close() {
      that.openInfo = {};
      that.openShow = false;
      that.amount = null;
    },
    getbalancelist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
            that.balancelist = balancelist;
            that.targettype = balancelist[1];
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
            that.balancelist = balancelist;
          }
        })
        .catch(res => {});
    },

    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
<style lang="scss" scoped>
.stddss{
  height: 100vh;
}
.tabVox {
  background: #f1f1f1;
  display: flex;
  justify-content: space-between;
  height: 1.2rem;
  align-items: center;
  padding-top: 5px;

  .tab {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.4rem;
  }

  .tab.atc {
    background: #fff;
    border-radius: 10px 10px 0 0;
    color: #158bf4;
    position: relative;
  }

  .atc::after {
    content: ' ';
    position: absolute;
    bottom: 2px;
    width: 30px;
    height: 3px;
    left: calc(50% - 15px);
    z-index: 200;
    background: #158bf4;
    border-radius: 4px;
  }
}

.qibao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.4rem;
  box-sizing: border-box;
  border-bottom: 1px solid #f8f8f8;

  .fes {
    font-size: 0.4rem;
    font-weight: 700;
  }

  .imgs {
    flex: 1;

    img {
      width: 0.4rem;
      margin-left: 0.1rem;
      display: flex;
      align-items: center;
    }
  }

  .btns {
    color: #697b8c;
    font-size: 0.28rem;
  }
}

.mesg {
  display: flex;
  align-items: center;
  height: 2rem;
  border-bottom: 1px solid #f8f8f8;

  .bosgf {
    flex: 1;
    text-align: center;

    .top {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.4rem;

      img {
        width: 0.4rem;
        margin-right: 0.1rem;
      }
    }

    .bots {
      margin-top: 0.1rem;
      font-size: 0.5rem;
      color: #158bf4;

      span {
        font-size: 0.23rem;
      }
    }
  }
}

.gameBox {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 10px;

  .lis {
    width: 25%;
    text-align: center;
    box-sizing: border-box;
    padding-top: 0.4rem;

    .name {
      font-size: 0.23rem;
      color: #383b43;
      line-height: 1;
      overflow: hidden; //超出隐藏
      text-overflow: ellipsis; //显示省略号
      white-space: nowrap; //强制不换行
    }

    .num {
      font-size: 0.23rem;
      color: #cbced8;
      margin-top: 0.2rem;
    }

    img {
      width: 0.32rem;
    }
  }
}

.usrse {
  background: #fff;
  box-sizing: border-box;
  padding-top: 5px;

  .hgs {
    width: calc(100% - 40px);
    margin: 0 auto;
  }

  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
    margin-top: 10px;
    font-weight: 700;
  }

  .imgsa {
    position: relative;
    height: 2rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.2rem;

    .bisn {
      width: 0.8rem;
      position: absolute;
      bottom: 0.3rem;
      left: 1.4rem;
    }

    img {
      width: 2rem;
      border-radius: 50%;
    }
  }
}

.card {
  .lis {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    height: 1.2rem;
    border-bottom: 1px solid #f8f8f8;
    img {
      width: 0.4rem;
    }
  }
}

.poptit {
  height: 1.4rem;
  font-size: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 22;
}

.cardhgs {
  display: flex;
  align-items: center;
  color: #158bf4;
  font-size: 0.23rem;
  height: 1.2rem;

  img {
    width: 0.8rem;
    margin: 0 1rem;
  }

  span {
    display: inline-block;
    margin: 0 4px;
    font-size: 0.23rem;
  }
}

.mianzhuan {
  display: flex;
  height: 2rem;
  align-items: center;
  margin: 14px auto;
  box-sizing: border-box;
  padding: 0 20px;
  background: #fff;

  .lfs {
    flex: 1;
    font-weight: 700;
    font-size: 0.4rem;
  }

  .ces {
    color: #a5a9b3;
    padding-right: 10px;
    font-size: 0.3rem;
  }
}

.zhuanzang {
  background: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  .tit {
    display: flex;
    align-items: center;
    height: 1.2rem;
    border-bottom: 1px solid #f8f8f8;
    img {
      width: 0.6rem;
    }
    .lesg {
      width: calc(50% - 0.6rem);
      display: flex;
      justify-content: center;
      font-size: 0.4rem;
      font-weight: 700;
      justify-content: center;
      span {
        color: #a5a9b3;
        font-size: 0.4rem;
        padding-left: 10px;
      }
    }
  }
}



















.venuesTansfer .head {
    width: 100%;
    height: 1.17333rem;
    border-bottom: .02667rem solid #f4f4f4;
    background: #fff
}

.venuesTansfer .head img {
    width: .64rem;
    height: .64rem;
    margin-left: .13333rem;
    margin-top: .26667rem
}

.venuesTansfer .head .head-text {
    margin-left: 3.33333rem;
    font-size: .45333rem;
    color: #424653;
    font-weight: 700
}

.venuesTansfer .accounts-scroll {
    padding: .26667rem;
    background-color: #f3f3f6
}

.venuesTansfer .accounts-scroll .automatic {
    width: 9.46667rem;
    height: 1.33333rem;
    background: #fff;
    box-shadow: 0 0 .16rem 0 rgba(156, 163, 191, .35);
    border-radius: .21333rem;
    margin-bottom: .26667rem
}

.venuesTansfer .accounts-scroll .automatic .text {
    font-family: PingFang SC;
    font-weight: 700;
    color: #424653
}

.venuesTansfer .accounts-scroll .automatic .text .tit {
    font-size: .37333rem;
    font-family: PingFang SC;
    font-weight: 700;
    color: #424653
}

.venuesTansfer .accounts-scroll .automatic .text span {
    font-size: .26667rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9ca3bf;
    margin-top: .13333rem
}

.venuesTansfer .accounts-scroll .automatic .text .Popovershow {
    width: .32rem;
    height: .32rem;
    margin-left: .05333rem;
    -webkit-transform: translateY(.02667rem);
    -ms-transform: translateY(.02667rem);
    transform: translateY(.02667rem)
}

.venuesTansfer .accounts-scroll .automatic {
    height: 1.06667rem;
    background-color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding-left: .42667rem;
    box-sizing: border-box;
    padding-right: .4rem
}

.venuesTansfer .accounts-scroll .automatic .desShow {
    margin-top: .08rem;
    min-width: 3.2rem;
    max-width: 11.2rem;
    background-color: #424653;
    position: absolute;
    margin-bottom: 2.4rem;
    border-radius: .16rem;
    padding-left: .16rem;
    padding-right: .16rem;
    padding-top: .08rem;
    padding-bottom: .08rem;
    line-height: .48rem;
    margin-left: 0;
    z-index: 999;
    border: .02667rem solid #ccc;
    font-size: .26667rem;
    margin-right: 0;
    box-sizing: border-box;
    color: #fff
}

.venuesTansfer .accounts-scroll .automatic .text {
    font-size: .37333rem;
    font-family: PingFang SC, sans-serif;
    font-weight: 500;
    color: #1f285a
}

.venuesTansfer .accounts-scroll .automatic .van-switch--on {
    background-color: #ff8439 !important
}

.venuesTansfer .accounts-scroll .user-handle {
    width: 9.46667rem;
    min-height: 5.62667rem;
    background-color: #fff;
    box-shadow: 0 0 .10667rem 0 rgba(156, 163, 191, .35);
    border-radius: .26667rem;
    margin-bottom: .26667rem;
    padding-bottom: .53333rem
}

.venuesTansfer .accounts-scroll .user-handle .first-handle {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-justify-content: space-around;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    height: 1.33333rem;
    border-bottom: .02667rem solid #dcdcdc
}

.venuesTansfer .accounts-scroll .user-handle .first-handle .from,
.venuesTansfer .accounts-scroll .user-handle .first-handle .to {
    width: 4.26667rem;
    cursor: pointer
}

.venuesTansfer .accounts-scroll .user-handle .first-handle .item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: 1.33333rem;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.venuesTansfer .accounts-scroll .user-handle .first-handle .item span {
    font-size: .37333rem;
    font-family: PingFang SC;
    color: #424653;
    margin-right: .26667rem;
    font-weight: 700
}

.venuesTansfer .accounts-scroll .user-handle .first-handle .item .arrowicon {
    width: .13333rem;
    height: .24rem
}

.venuesTansfer .accounts-scroll .user-handle .first-handle .icon {
    width: .61333rem;
    height: .32rem
}

.venuesTansfer .accounts-scroll .user-handle .second-handle {
    height: 2.16rem;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-left: .8rem;
    margin-right: .8rem;
    box-sizing: border-box;
    padding-bottom: .4rem
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .bankbalance {
    height: .85333rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: .37333rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9ca3bf
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .bankbalance .number {
    color: #ff8439;
    margin-left: .13333rem
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .van-cell:after {
    content: none !important
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-justify-content: space-around;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: .16rem;
    position: relative
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .betInput {
    padding: .26667rem 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -webkit-align-items: flex-end;
    -ms-flex-align: end;
    align-items: flex-end;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
    border-bottom: .02667rem solid #dcdcdc
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .betInput .van-cell__title {
    font-size: .37333rem;
    font-family: PingFang SC;
    font-weight: 700;
    color: #424653;
    margin: 0;
    width: .26667rem;
    -webkit-transform: translatey(.02667rem);
    -ms-transform: translatey(.02667rem);
    transform: translatey(.02667rem)
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .betInput .van-cell__value {
    margin-left: .4rem;
    width: 6.56rem
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .betInput .van-cell__value .van-field__body input {
    font-size: .66667rem;
    font-family: DIN;
    font-weight: 500;
    color: #424653;
    border: none
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .betInput .van-cell__value .van-field__body input::-webkit-input-placeholder {
    font-size: .48rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9ca3bf
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .betInput .van-cell__value .van-field__body input:-moz-placeholder,
.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .betInput .van-cell__value .van-field__body input::-moz-placeholder {
    font-size: .48rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9ca3bf
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .betInput .van-cell__value .van-field__body input:-ms-input-placeholder {
    font-size: .48rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9ca3bf
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .van-cell:after {
    content: none
}

.venuesTansfer .accounts-scroll .user-handle .second-handle .inputArea .all-into {
    width: 1.86667rem;
    text-align: right;
    font-size: .32rem;
    font-family: PingFang SC;
    font-weight: 700;
    color: #ff8439;
    position: absolute;
    right: .26667rem;
    bottom: .4rem
}

.venuesTansfer .accounts-scroll .user-handle .lastbutton {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    width: 8rem;
    height: 1.2rem;
    background: -webkit-linear-gradient(left, #ff8846, #ffbe61);
    background: linear-gradient(90deg, #ff8846, #ffbe61);
    border-radius: .61333rem;
    opacity: .4;
    font-size: .42667rem;
    font-family: PingFang SC;
    font-weight: 700;
    color: #fff;
    margin: 0 auto;
    margin-top: .37333rem
}

.venuesTansfer .accounts-scroll .user-handle .hasInput {
    opacity: 1 !important
}

.venuesTansfer .accounts-scroll .topArea {
    background: #fff;
    box-shadow: 0 0 .16rem 0 rgba(156, 163, 191, .35);
    border-radius: .21333rem;
    box-sizing: border-box;
    padding-top: .13333rem;
    min-height: auto !important
}

.venuesTansfer .van-popup {
    min-height: 8rem;
    padding-top: .26667rem;
    padding-bottom: .66667rem
}

.venuesTansfer .van-popup .van-action-sheet__item {
    padding-top: 0;
    padding-bottom: 0;
    height: 1.33333rem;
    border-bottom: .02667rem solid #f2f3f5
}

.actionSheetPop {
    width: 6.93333rem;
    max-height: 10rem;
    overflow: scroll;
    background: #fff;
    border-radius: .26667rem
}

.actionSheetPop .actionItem {
    width: 6.93333rem;
    height: 1.33333rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding-left: .4rem;
    padding-right: .4rem;
    border-bottom: .02667rem solid #e1e1e1
}

.actionSheetPop .actionItem,
.actionSheetPop .actionItem .left {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.actionSheetPop .actionItem .left {
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start
}

.actionSheetPop .actionItem .left .game {
    font-size: .37333rem;
    font-family: DIN;
    font-weight: 500;
    color: #424653
}

.actionSheetPop .actionItem .left .hot {
    width: .69333rem;
    height: .34667rem;
    margin-left: .4rem
}

.actionSheetPop .actionItem .right {
    width: .45333rem;
    height: .4rem
}

.actionSheetPop::-webkit-scrollbar {
    display: none !important
}

.venuesDetail .Popovershow {
    width: .26667rem;
    height: .26667rem
}

.venuesDetail .venues {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    margin-top: .32rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding-left: .42667rem;
    padding-right: .4rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    font-family: PingFang-SC-Medium;
    font-size: .32rem;
    padding-bottom: .45333rem
}

.venuesDetail .venues .left-nums {
    color: #424653
}

.venuesDetail .venues span {
    color: #a5a9b3;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: right;
    padding-right: .13333rem
}

.venuesDetail .venues img {
    width: .46667rem;
    height: .46667rem;
    margin-left: .24rem
}

.venuesDetail .venues .disable {
    pointer-events: none
}

.venuesDetail .venuesList .top {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: 1.86667rem;
    background: #f3f3f6;
    border-radius: .13333rem;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    margin-left: .4rem;
    margin-right: .4rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding-left: .42667rem;
    padding-right: .4rem
}

.venuesDetail .venuesList .top .left {
    width: 4.8rem;
    height: 100%
}

.venuesDetail .venuesList .top .left .left-top {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: .48rem;
    height: .32rem
}

.venuesDetail .venuesList .top .left .left-top img {
    width: .32rem;
    height: .29333rem;
    margin-right: .26667rem;
    vertical-align: middle;
    margin-top: .02667rem
}

.venuesDetail .venuesList .top .left .left-top .main-number {
    font-size: .32rem;
    font-family: PingFang SC;
    font-weight: 700;
    color: #424653
}

.venuesDetail .venuesList .top .left .money {
    font-size: .37333rem;
    font-family: DIN;
    font-weight: 500;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    color: #424653;
    height: .37333rem;
    margin-top: .24rem
}

.venuesDetail .venuesList .top .left .money,
.venuesDetail .venuesList .top .onClickBack {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    display: flex
}

.venuesDetail .venuesList .top .onClickBack {
    width: 2.4rem;
    height: 1.06667rem;
    background: #fff;
    border-radius: .21333rem;
    padding: 0;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center
}

.venuesDetail .venuesList .top .onClickBack .van-button__text {
    text-align: center;
    color: #c4a47d;
    font-family: PingFang-SC-Medium;
    font-size: .37333rem;
    font-family: PingFang SC;
    font-weight: 700;
    color: #ff8439
}

.venuesDetail .venuesList .listbox {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-content: flex-start;
    -ms-flex-line-pack: start;
    align-content: flex-start;
    padding-left: .32rem;
    padding-right: .32rem
}

.venuesDetail .venuesList .listbox .item {
    width: 25%;
    height: 2rem;
    border-bottom: .02667rem solid #eee
}

.venuesDetail .venuesList .listbox .item,
.venuesDetail .venuesList .listbox .item .inner-box {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center
}

.venuesDetail .venuesList .listbox .item .inner-box {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    border-right: .02667rem solid #eee;
    width: 100%;
    padding-left: .08rem;
    padding-right: .08rem
}

.venuesDetail .venuesList .listbox .item .inner-box .out {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.venuesDetail .venuesList .listbox .item .inner-box .out .tittleText {
    font-size: .29333rem;
    font-family: PingFang SC;
    color: #424653;
    max-height: 1.2rem;
    line-height: .4rem;
    overflow: hidden;
    word-break: break-all
}

.venuesDetail .venuesList .listbox .item .inner-box .out img {
    margin-left: .05333rem
}

.venuesDetail .venuesList .listbox .item .inner-box .moneyText {
    margin-top: .18667rem;
    font-size: .29333rem;
    font-family: DIN;
    font-weight: 500;
    color: #7e88ad
}

.venuesDetail .venuesList .listbox .item .inner-box .blue {
    color: #68a6f7
}

.venuesDetail .venuesList .listbox .item .desShow {
    min-width: 3.2rem;
    max-width: 3.73333rem;
    background-color: #424653;
    position: absolute;
    margin-bottom: 2.4rem;
    border-radius: .16rem;
    padding-left: .16rem;
    padding-right: .16rem;
    padding-top: .08rem;
    padding-bottom: .08rem;
    line-height: .48rem;
    margin-left: 1.06667rem;
    z-index: 999;
    border: .02667rem solid #ccc;
    font-size: .26667rem;
    margin-right: .4rem;
    box-sizing: border-box;
    color: #fff
}

.venuesDetail .venuesList .listbox .bbNone {
    border-bottom: none !important
}

.venuesDetail .venuesList .listbox .item:nth-child(4n) .inner-box {
    border-right: none
}


</style>



// WEBPACK FOOTER //
// src/components/transfer.vue